import React from 'react';
import { TableRow, TableCell, Stack, Typography, Box} from '@mui/material';
import CopyButton from '../../CustomComponents/CopyButton';
import WasteEstimateDisplay from './WasteEstimateDisplay';

function PackItemRow({ item, isSelected, onSelect, viewMode = 'standard' }) {
    return (
        <TableRow 
            hover 
            selected={isSelected}
            onClick={onSelect}
            sx={{ cursor: 'pointer' }}
        >
            <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider' }}>
                <Stack spacing={0.5}>
                    <Typography variant="normal">
                        {item.item_name}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center'}}>
                        <Stack sx={{ overflow: 'hidden', flex: 1 }}>
                            <Typography variant="caption" color="text.secondary" noWrap>
                                {item.vendor_name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" noWrap>
                                Qty: {parseFloat(item.quantity_in_pack).toFixed(0)} | {item.catalog_number}
                            </Typography>
                        </Stack>
                        <CopyButton 
                            textToCopy={item.catalog_number} 
                            hoverText="Copy Part Number"
                        />                      
                    </Box>
                </Stack>
            </TableCell>
            <TableCell>
                {viewMode === 'standard' && (
                    <Stack direction="row" spacing={1} sx={{ textAlign: 'center' }}>
                        <WasteEstimateDisplay 
                            value={item.waste_estimate.low_estimate}
                            sx={{ flex: 1 }}
                        />
                        <WasteEstimateDisplay 
                            value={item.waste_estimate.medium_estimate}
                            sx={{ flex: 1 }}
                        />
                        <WasteEstimateDisplay 
                            value={item.waste_estimate.high_estimate}
                            sx={{ flex: 1 }}
                        />
                    </Stack>
                )}
                {viewMode === 'periop' && (
                    <Stack direction="row" spacing={2} sx={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                        <WasteEstimateDisplay value={item.waste_estimate.low_estimate} rounded />
                        <Typography variant="caption" lineHeight={1}>-</Typography>
                        <WasteEstimateDisplay value={item.waste_estimate.high_estimate} rounded />
                    </Stack>
                )}
            </TableCell>
            <TableCell sx={{ textAlign: 'center', borderLeft: '1px solid', borderColor: 'divider' }}>
                {`${(item.reviewed_usage_percentage * 100)?.toFixed( viewMode === 'standard' ? 2 : 0 ) ?? 0}%`}
            </TableCell>
        </TableRow>
    );
}

export default PackItemRow;